// extracted by mini-css-extract-plugin
module.exports = {"triangle":"bubble_triangle__2iEOj","container":"bubble_container__3g6hO","inner":"bubble_inner__3U2JU"};